import React, {Component} from 'react';
import Collapsible from 'react-collapsible';
import AccordionHeader from './AccordionHead';
import AccordionContent from './AccordionContent';
import AccordionFooter from './AccordionFooter';

export default class extends Component {
  render() {

    const data = [
      {
        head: {
          label: "WORKSHOP DESCRIPTION",
          icon: "ic-flag-ico",
          caption: "Family Interventions for Adults: Foundation level training in Family Therapy",
          withBtn: false
        },
        content:{},

      },
      {
        head: {
          label: "module 1",
          number: "1",
          caption: "Diagnosing and Managing Atrial Fibrillation",
          withBtn: false,
          btn: {
            type: 'start',
            text: 'start'
          }
        }
      },
      {
        head: {
          label: "module 2",
          number: "2",
          caption: "Family Interventions for Adults: Foundation level training in Family Therapy",
          withBtn: true,
          btn: {
            type: 'completed',
            text: 'completed'
          }
        }
      },
      {
        head: {
          label: "module 3",
          number: "3",
          caption: "Family Interventions for Adults: Foundation level training in Family Therapy",
          withBtn: true,
          btn: {
            type: 'progress',
            text: 'in progress'
          }
        }
      },
      {
        head: {
          label: "module 4",
          number: "4",
          caption: "Family Interventions for Adults: Foundation level training in Family Therapy",
          withBtn: true,
          btn: {
            type: 'start',
            text: 'start'
          }
        }
      }
    ];

    return (<div>
      {data.map((item, index) => {

        const accordionHeader = (
          <AccordionHeader
            label={item.head.label}
            icon={item.head.icon}
            number={item.head.number}
            caption={item.head.caption}
            withBtn={item.head.withBtn || false}
            btn={item.head.btn || {}}
          />
        );

        return (
          <Collapsible
            className="accordion-item"
            openedClassName="accordion-item is-active"
            trigger={accordionHeader}
            key={index}>
            <AccordionContent/>
            <AccordionFooter/>
          </Collapsible>
        )
      })}
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/blocks/accordion/AccordionContainer.jsx